var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-footer"},[_c('Page',{attrs:{"total":_vm.total,"page-size":_vm.pageSize,"page-size-opts":_vm.pageSizeOpts,"show-total":_vm.showTotal,"show-sizer":_vm.showSizer},on:{"on-change":_vm.changePage,"on-page-size-change":_vm.changePageSize}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc2dfa9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--0-1!./src/views/my-components/page-footer/page-footer.vue
// module id = null
// module chunks = 